export default __webpack_public_path__ + "static/media/E2BAuto-300x250-px.784a9067.jpg";